export default __webpack_public_path__ + "cd942952ff64b93a806dc6b482c173c4.svg";